import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { useComponentClassName } from "../auxiliary/useComponentClassName.js";
const Spinner = memo(() => /* @__PURE__ */ jsx("div", { className: useComponentClassName("spinner") }));
Spinner.displayName = "Spinner";
export {
  Spinner
};
//# sourceMappingURL=Spinner.js.map
